import { combineReducers } from 'redux';
import productReducer from '../features/products/products';
import appReducer from '../features/app/app';
import userReducer from '../features/user/user';

export default combineReducers({
  products: productReducer,
  app: appReducer,
  user: userReducer
});
